import { Component, signal } from '@angular/core';
import { HpaServiceService } from '../../../Services/HPAService/hpa-service.service';
import { HpaSharedServiceService } from '../../../Services/HPAService/hpa-shared-service.service';
import { SharedDataService } from '../../../Services/SharedServices/shared-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hpa-first-selection',
  templateUrl: './hpa-first-selection.component.html',
  styleUrl: './hpa-first-selection.component.css'
})
export class HpaFirstSelectionComponent {
  scrollToCommonSecondComponent() {
    const hpSecondComponent = document.querySelector('app-second-selection');
    if (hpSecondComponent) {
      hpSecondComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
constructor(private sharedDataService: SharedDataService,private hpaService:HpaServiceService,private hpaSharedService:HpaSharedServiceService,private router: Router){};
specData:any={};
dutyCycle:any;
Series:any;
ExactRatio:any;
userSelectedData:any={};
sizeSpeedRatio:any={
  size:"",
    ratio:"",
    speed:"",
    inputPower:"",
    units:""
};
public showcdinfo: boolean = false;
public showspinfo: boolean = false;
ngOnInit(){
  // this.sharedDataService.series$.subscribe(series => {
  //   console.log('Series received in HomeComponent in HPAA:', series);
  //   if (series) {
  //     console.log("MY SERIES IS From HPA final output", series);
  //     this.Series = series;
  //   }
  // });
  const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
  this.sharedDataService.getSeriesData().subscribe(data => {
    this.Series = data;
    this.signalStatus=true;
    this.panelOpenState = signal(this.signalStatus);
  });
  this.hpaSharedService.getFormData().subscribe(data => {
    this.dutyCycle = data.selectedDutyCycle; 
    console.log("MY Duty IS From HPA final output", this.dutyCycle);
  });
  this.hpaSharedService.specification$.subscribe((specificationData:any) => 
    {
      this.getExactRatio(specificationData.size,specificationData.ratio);
      this.sizeSpeedRatio.size = specificationData.size;
        this.sizeSpeedRatio.speed = specificationData.speed
        this.sizeSpeedRatio.ratio = specificationData.ratio
      this.specData = {
        size:specificationData.size,
        ratio:specificationData.ratio,
        exactRatio:this.ExactRatio,
        speed:specificationData.speed,
        iP_MechanicalImp:(specificationData.iP_Mechanical)=="N/A"?specificationData.iP_Mechanical:specificationData.iP_Mechanical || "null",
        iP_ThermalImp:(specificationData.iP_Thermal)=="N/A"?specificationData.iP_Thermal:specificationData.iP_Thermal || "null",
        fan_Thermal:(specificationData.fan_Thermal)=="N/A"?specificationData.fan_Thermal:specificationData.fan_Thermal || "null",
        InputPowerFanThermal_Met:(specificationData.inputPowerFanThermal_Met)=="N/A"?specificationData.inputPowerFanThermal_Met:specificationData.inputPowerFanThermal_Met || "null",
        efficiency:(specificationData.efficiency)=="N/A"?specificationData.efficiency:specificationData.efficiency + " %" || "null",
        outputTorqueImp:(specificationData.outputTorque)=="N/A"?specificationData.outputTorque:specificationData.outputTorque || "null",
        inertiaSolidlb:specificationData.inertiaSolidlb,
        inertiaSolidkg:specificationData.inertiaSolidkg,
        inertiaHollowlb:specificationData.inertiaHollowlb,
        inertiaHollowkg:specificationData.inertiaHollowkg,
        inertiaSolidShaftFanlb:specificationData.inertiaSolidShaftFanlb,
        inertiaSolidShaftFankg:specificationData.inertiaSolidShaftFankg,
        inertiaHollowShaftFanlb:specificationData.inertiaHollowShaftFanlb,
        inertiaHollowShaftFankg:specificationData.inertiaHollowShaftFankg,
        std_Backlash:specificationData.std_Backlash,
        low_Backlash:specificationData.low_Backlash,
        iP_MechanicalMet:parseFloat((parseFloat(specificationData.iP_Mechanical) * 0.7456999).toFixed(1)),
        iP_ThermalMet:parseFloat((parseFloat(specificationData.iP_Thermal) * 0.7456999).toFixed(1)),
        outputTorqueMet:parseFloat((parseFloat(specificationData.outputTorque) * 0.1129848).toFixed(2)),
        specServiceFactor:(specificationData.specServiceFactor=="N/A")?specificationData.specServiceFactor : specificationData.specServiceFactor
    };

    const specSFElements = document.getElementsByClassName('sericeFactorStyle');
for (let i = 0; i < specSFElements.length; i++) {
  const element = specSFElements[i] as HTMLElement;
  if (Number(specificationData.specServiceFactor) < Number(this.userSelectedData.SelectedServiceFactor)) {
      element.style.setProperty('background-color', '#dc3545', 'important');
  } else {
      element.style.setProperty('background-color', '#28a745', 'important');
  }
}
    });
    this.hpaSharedService.getFormData().subscribe(data => {
      this.sizeSpeedRatio.inputPower = data.selectedInputPower;
        this.sizeSpeedRatio.units = data.selectedUnits;
      this.userSelectedData={
        SelectedInputPower:data.selectedInputPower || "Null",
        SelectedUnits:data.selectedUnits || "Null",
        SelectedSpeed:data.selectedSpeed || "Null",
        SelectedRatio:data.selectedRatio || "Null",
        SelectedDutyCycle:data.selectedDutyCycle || "Null",
        SelectedServiceFactor:data.selectedServiceFactor || "Null",
        SelectedOutputSpeed:data.selectedOutputSpeed || "Null"
      };
    });
}


largerReducer():void{
  const parameters={
    size:this.sizeSpeedRatio.size,
    speed:this.sizeSpeedRatio.speed,
    ratio:this.sizeSpeedRatio.ratio,
    Inputpower_Them : this.sizeSpeedRatio.inputPower,
    units: this.sizeSpeedRatio.units
  };
  this.hpaService.getLargerReducer(parameters).subscribe(result => {
        if(result.body==null){
      alert("No Larger Size available")
    }else
    {
      this.hpaSharedService.setSpecification(result.body);
    }
  });

}

smallerReducer():void{
  const parameters={
    size:this.sizeSpeedRatio.size,
    speed:this.sizeSpeedRatio.speed,
    ratio:this.sizeSpeedRatio.ratio,
    Inputpower_Them : this.sizeSpeedRatio.inputPower,
    units: this.sizeSpeedRatio.units
  };
  this.hpaService.getSmallerReducer(parameters).subscribe(result => {
    if(result.body==null){
      alert("No Smaller Size available")
    }else
    {
      this.hpaSharedService.setSpecification(result.body);
    }
  });

}
reducerFeature():void{
  this.hpaSharedService.setSize(this.sizeSpeedRatio);
}
// largerReducer():void{
//   const params={
//     Size: "RG"+this.sizeSpeedRatio.size,
//     Ratio:this.sizeSpeedRatio.ratio,
//     Speed:this.sizeSpeedRatio.speed
//   };
//   this.rgService.getRGLargerReducer(params).subscribe(result=>{
//     if(result.body==null){
//       alert("No Larger Size available")
//     }else
//     {
//       this.rgSharedService.setSpecification(result.body);
//     }
    
//     console.log(this.specData);
//   });
// }
// smallerReducer():void{
//   debugger;
//   const params={
//     Size: "RG"+this.sizeSpeedRatio.size,
//     Ratio:this.sizeSpeedRatio.ratio,
//     Speed:this.sizeSpeedRatio.speed
//   };
//   this.hpaService.getRGSmallerReducer(params).subscribe(result=>{
//     if(result.body==null){
//       alert("No Smaller Size available")
//     }else
//     {
//       this.rgSharedService.setSpecification(result.body);
//     }
    
//     console.log(this.specData);
//   });
// }
// reducerFeature():void{
//   this.rgSharedService.setSize(this.sizeSpeedRatio);
// }
getExactRatio(size:string,ratio:string){
  debugger;
  this.ExactRatio="";
  switch(size){
    case '100':
      switch(ratio){
        case '5.0':
          this.ExactRatio="5.143";
          break;
        case '7.5':
          this.ExactRatio="7.4";
          break;
        case '10.':
          this.ExactRatio="9.75";
          break;
        case '12.':
          this.ExactRatio="12.333";
          break;
        case '15.':
          this.ExactRatio="15.5";
          break;
        case '20.':
          this.ExactRatio="19.5";
          break;
		case '25.':
          this.ExactRatio="25";
          break;
		case '30.':
          this.ExactRatio="30";
          break;
		case '40.':
          this.ExactRatio="40";
          break;
		case '50.':
          this.ExactRatio="50";
          break;
		case '60.':
          this.ExactRatio="60";
          break;
		case '70.':
          this.ExactRatio="70";
          break;
      }
      break;
    case '125':
      switch(ratio){
        case '5.0':
          this.ExactRatio="5.143";
          break;
        case '7.5':
          this.ExactRatio="7.4";
          break;
        case '10.':
          this.ExactRatio="9.75";
          break;
        case '12.':
          this.ExactRatio="12.333";
          break;
        case '15.':
          this.ExactRatio="15.5";
          break;
        case '20.':
          this.ExactRatio="19.5";
          break;
		case '25.':
          this.ExactRatio="25";
          break;
		case '30.':
          this.ExactRatio="30";
          break;
		case '40.':
          this.ExactRatio="40";
          break;
		case '50.':
          this.ExactRatio="50";
          break;
		case '60.':
          this.ExactRatio="60";
          break;
		case '70.':
          this.ExactRatio="70";
          break;
      }
      break;
    case '160':
      switch(ratio){
        case '5.0':
          this.ExactRatio="5.125";
          break;
        case '7.5':
          this.ExactRatio="7.571";
          break;
        case '10.':
          this.ExactRatio="9.8";
          break;
        case '12.':
          this.ExactRatio="12.25";
          break;
        case '15.':
          this.ExactRatio="14.667";
          break;
        case '20.':
          this.ExactRatio="20.5";
          break;
        case '25.':
          this.ExactRatio="24.5";
          break;
		case '30.':
          this.ExactRatio="30";
          break;
		case '40.':
          this.ExactRatio="40";
          break;
		case '50.':
          this.ExactRatio="50";
          break;
		case '60.':
          this.ExactRatio="60";
          break;
		case '70.':
          this.ExactRatio="70";
          break;
      }
      break;
    case '200':
      switch(ratio){
        case '5.0':
          this.ExactRatio="5.1";
          break;
        case '7.5':
          this.ExactRatio="7.571";
          break;
        case '10.':
          this.ExactRatio="9.8";
          break;
        case '12.':
          this.ExactRatio="12.25";
          break;
        case '15.':
          this.ExactRatio="15.333";
          break;
        case '20.':
          this.ExactRatio="20.5";
          break;
        case '25.':
          this.ExactRatio="24.5";
          break;
		case '30.':
          this.ExactRatio="30";
          break;
		case '40.':
          this.ExactRatio="40";
          break;
		case '50.':
          this.ExactRatio="50";
          break;
		case '60.':
          this.ExactRatio="60";
          break;
		case '70.':
          this.ExactRatio="70";
          break;
      }
      break;
    default:
      break;
  }
}
}
